<template>
    <div>
        <div name="btns" class="simple-row clearfix">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="saveDoRel(null)">关联</button>
            </div>
        </div>
        <el-table class="thin" :data="devcClassifyTagSpecFieldList" ref="deviceImpInfoTable" border style="width: 100%; font-size: 12px">
            <el-table-column prop="classifyTagName" label="标签名称" width="220" align="left"></el-table-column>
            <el-table-column prop="custFieldTitle" label="字段名称" align="left"></el-table-column>
            <el-table-column prop="required" label="是否必填" width="200" align="left">
                <template slot-scope="rows">
                    <span v-if="rows.row.required" class="font-red">是</span>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="200" align="center"></el-table-column>
            <el-table-column label="操作" align="left" width="160">
                <template slot-scope="rows">
                    <i class="icon iconfont icon-arrow-top swb-btn swb-btn-link" @click="moveUpItem(rows.row.id, true)"></i>
                    <i class="icon iconfont icon-arrow-bottom swb-btn swb-btn-link" @click="moveUpItem(rows.row.id, false)"></i>
                    <span class="swb-btn swb-btn-link" @click="deleteDo(rows.row.id)">删除</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'

    import merchtComnApi from '../../api/merchtComn'

    import SwbDevcCustFieldListSelect from './DevcCustFieldListSelect';
    Vue.regist(SwbDevcCustFieldListSelect);

    export default {
        name: 'swb-devc-classify-tag-spec-filed-list',
        props: ["classifyTagId"],
        data: function () {
            return {
                devcClassifyTagSpecFieldList: [],
            }
        },
        created: function () {
            //
            this.getDataList();
        },
        methods: {
            getDataList(){
                let self = this;
                let postData = {};
                postData.classifyTagId = this.classifyTagId;
                //
                let theLoading = MsgBox.loading();
                merchtComnApi.getDevcClassifyTagSpecFields(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        //
                        self.devcClassifyTagSpecFieldList = result.data || [];
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            saveDoRel: function () {
                let self = this;
                let currentLength = 15 - this.devcClassifyTagSpecFieldList.length;
                let custFieldIds = this.devcClassifyTagSpecFieldList.pluck("custFieldId");
                let theDlg = Vue.$showDialog({
                    title: '标签关联字段',
                    showCloseBtn: true,
                    width: -600,
                    height: 800,
                    template: '<swb-devc-cust-field-list-select :custFieldIds="custFieldIds" ref="swb_devc_cust_field_list_select"></swb-devc-cust-field-list-select>',
                    data: {
                        custFieldIds: custFieldIds,
                    },
                    okClicked: function () {
                        let custFieldList = this.$refs.swb_devc_cust_field_list_select.getDlgResult() || [];
                        if(custFieldList.length > currentLength) {
                            MsgBox.warning("最多可关联15个字段，目前还可关联" + currentLength + "个");
                            return;
                        }
                        if(custFieldList.length > 0) {
                            let tagSpecFieldList = [];
                            for(let i = 0; i < custFieldList.length; i++) {
                                let custField = custFieldList[i];
                                let tagSpecField = {
                                    custFieldId: custField.id,
                                    custFieldName: custField.name,
                                    custFieldTitle: custField.title,
                                    required: custField.required,
                                };
                                tagSpecFieldList.push(tagSpecField);
                            }
                            let postData = {
                                id: self.classifyTagId,
                                devcClassifyTagSpecFields: tagSpecFieldList
                            };
                            let theLoading = MsgBox.loading();
                            merchtComnApi.saveDevcClassifyTagSpecFields(postData, function (result) {
                                theLoading.close();
                                if(result.type == 'info') {
                                    theDlg.close();
                                    //
                                    self.getDataList();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        } else {
                            MsgBox.warning("请选择要关联的字段");
                        }
                        return false;
                    }
                });
            },
            moveUpItem: function (id, toUp) {
                let self = this;
                let data = {};
                data.id = id;
                data.toUp = toUp;
                merchtComnApi.doDevcClassifyTagSpecFieldMove(data, function (result) {
                    if(result.type == "info") {
                        self.$message.success("操作成功");
                        //
                        self.getDataList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            deleteDo: function (id) {
                let self = this;
                this.$confirm('确定删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {
                        id: id
                    };
                    let theLoad = MsgBox.loading();
                    merchtComnApi.deleteDevcClassifyTagSpecFieldById(postData, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            MsgBox.success("删除成功");
                            //
                            self.getDataList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/devcCust/DevcClassifyTagSpecFieldList.vue